<template>
  <v-data-table
    v-bind="tableProps"
    dense
    :headers="headers"
    :items="data"
    :loading="loading"
    @click:row="onRowClick"
  >
    <template v-slot:[`item.warehouse_id`]="{ item }">
      {{ item.warehouse_id[1] }}
    </template>

    <template v-slot:[`item.value`]="{ item }">
      {{ Math.round(item.value) }}%
    </template>
  </v-data-table>
</template>

<script>
import { useDataTable } from "@/composables/api/data-table.js";

export default {
  setup() {
    const { data, loading, headers, onRowClick, tableProps } =
      useDataTable("delivery_rate");

    return {
      data,
      loading,
      headers,
      onRowClick,
      tableProps
    };
  }
};
</script>

<style></style>
